<div class="container-fluid">
  <div class="report-header">
    <div>
      <h1 class="report-title">Funil de Orçamento</h1>
      <p class="report-subtitle">Acompanhe status, conversão e tempo de fechamento.</p>
    </div>
  </div>

  <div class="panel report-filters">
    <div class="report-filters__grid">
      <div class="filter-field">
        <label for="filterStart">Período (início)</label>
        <input
          id="filterStart"
          type="date"
          class="form-control"
          [(ngModel)]="filterStart"
          (change)="applyFilters()"
        />
      </div>
      <div class="filter-field">
        <label for="filterEnd">Período (fim)</label>
        <input
          id="filterEnd"
          type="date"
          class="form-control"
          [(ngModel)]="filterEnd"
          (change)="applyFilters()"
        />
      </div>
      <div class="filter-field">
        <label for="filterConsultor">Consultor</label>
        <select
          id="filterConsultor"
          class="form-control"
          [(ngModel)]="filterConsultor"
          (change)="applyFilters()"
        >
          <option value="TODOS">Todos</option>
          <option *ngFor="let consultor of consultores" [value]="consultor">{{ consultor }}</option>
        </select>
      </div>
      <div class="filter-field">
        <label for="filterStatus">Status</label>
        <select
          id="filterStatus"
          class="form-control"
          [(ngModel)]="filterStatus"
          (change)="applyFilters()"
        >
          <option value="TODOS">Todos</option>
          <option *ngFor="let status of statusColumns" [value]="status">{{ status }}</option>
        </select>
      </div>
    </div>
  </div>

  <div class="report-kpis">
    <div class="kpi-card">
      <div class="kpi-label">Total de Orçamento</div>
      <div class="kpi-value">{{ total }}</div>
    </div>
    <div class="kpi-card">
      <div class="kpi-label">Ganhos</div>
      <div class="kpi-value">{{ ganhos }}</div>
    </div>
    <div class="kpi-card">
      <div class="kpi-label">Perdidos</div>
      <div class="kpi-value">{{ perdidos }}</div>
    </div>
    <div class="kpi-card">
      <div class="kpi-label">Conversão</div>
      <div class="kpi-value">{{ conversao | number: '1.0-1' }}%</div>
    </div>
    <div class="kpi-card">
      <div class="kpi-label">Tempo médio até Ganho</div>
      <div class="kpi-value">{{ mediaGanho }} dias</div>
    </div>
    <div class="kpi-card">
      <div class="kpi-label">Tempo médio até Perdido</div>
      <div class="kpi-value">{{ mediaPerdido }} dias</div>
    </div>
  </div>

  <div class="panel report-funnel">
    <div class="funnel-grid">
      <div class="funnel-column" *ngFor="let summary of statusSummary">
        <div class="funnel-header" [style.background]="getStatusColor(summary.status)">
          <span class="funnel-title">{{ summary.status }}</span>
          <span class="funnel-count">{{ summary.count }}</span>
        </div>
        <div class="funnel-body">
          <div class="funnel-total">Total: {{ formatCurrency(summary.total) }}</div>
          <div class="funnel-mini">
            <div class="funnel-mini__title">Mais antigos</div>
            <div class="funnel-mini__item" *ngFor="let item of summary.oldest">
              <span>{{ formatNumeroOrcamento(item) }}</span>
              <span class="muted">{{ getDiasEmAberto(item) }} dias</span>
            </div>
            <div class="funnel-mini__empty" *ngIf="!summary.oldest.length">Sem itens.</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="panel report-table">
    <div class="wf-table-card">
      <table class="wf-table">
        <thead>
          <tr>
            <th class="col-number">Número</th>
            <th>Cliente</th>
            <th>Veículo</th>
            <th class="col-user">Consultor</th>
            <th class="col-status">Status</th>
            <th class="col-date">Abertura</th>
            <th class="col-value">Valor</th>
            <th class="col-days">Dias em aberto</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of tableItems">
            <td class="col-number">{{ formatNumeroOrcamento(item) }}</td>
            <td>{{ item.clienteNome }}</td>
            <td>{{ getVeiculoLabel(item) }}</td>
            <td class="col-user">{{ getConsultorNome(item) }}</td>
            <td class="col-status">
              <span
                class="status-pill"
                [style.background]="getStatusColor(getStatusAtendimento(item))"
              >
                {{ getStatusAtendimento(item) }}
              </span>
            </td>
            <td class="col-date">{{ getDataAbertura(item) | date: 'dd/MM/yyyy' }}</td>
            <td class="col-value">{{ formatCurrency(getValor(item)) }}</td>
            <td class="col-days">{{ getDiasEmAberto(item) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
